module.exports = __webpack_public_path__ + "static/media/checkoutHeader.12df0e33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/newCheckout/checkoutHeader.svg
// module id = 1192
// module chunks = 0